<template>
  <div
    :class="{
      'booster-button--has-value': value,
      'booster-button--rating': !!rating,
      'booster-button--sidebar': isSidebar,
      'booster-button--mobile': isMobile,
      'booster-button--header': isHeader,
    }"
    class="booster-button">
    <div
      :style="picStyle"
      class="booster-button__pic">
      <img
        :src="pic"
        alt=""
        class="booster-button__img">
      <transition name="transition--opacity">
        <div
          v-if="counter"
          class="booster-button__counter"
          :class="{ 'booster-button__counter--boolean': counterType === 'boolean' }">
          <template v-if="counterType === 'number'">
            {{ counter }}
          </template>
        </div>
      </transition>

      <div
        v-if="rating !== 0"
        class="booster-button__rating">
        <img
          src="/images/icons/star-white.svg"
          width="8"
          height="8"
          alt=""
          class="booster-button__rating-icon">
        {{ rating.toFixed(1) }}
      </div>
    </div>

    <div class="booster-button__text">
      <div
        v-if="value && !isMobile"
        class="booster-button__caption">
        {{ title }}
      </div>

      <div class="booster-button__title">
        {{ isMobile ? title : (value || title) }}
      </div>
    </div>

    <div
      v-if="counter && isMobile"
      class="booster-button__counter booster-button__counter--mobile"
      :class="{ 'booster-button__counter--boolean': counterType === 'boolean' }">
      <template v-if="counterType === 'number'">
        {{ counter }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoosterButton',

  props: {
    pic: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    active: {
      type: Boolean,
      default: false,
    },

    value: {
      type: String,
      default: '',
    },

    counter: {
      type: Number,
      default: 0,
    },

    counterType: {
      type: String,
      default: 'number',
      validate: (v) => ['number', 'boolean'].includes(v),
    },

    rating: {
      type: Number,
      default: 0,
    },

    isSidebar: {
      type: Boolean,
      default: false,
    },

    isHeader: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMobile: false,
    };
  },

  computed: {
    bgColor() {
      if (this.active) {
        return '#5f73fa';
      }

      return '#354A6C';
    },
    picStyle() {
      return {
        '--bg-color': this.bgColor,
      };
    },
  },

  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>

<style lang="scss" scoped>
.booster-button {
  font-size: $text-13px;
  font-weight: 500;
  line-height: 1.38;
  align-items: center;
  display: flex;
  cursor: pointer;
  position: relative;
  flex-direction: column;

  &:hover {
    .booster-button__pic {
      background-color: $color--basic-blue;
    }
  }
}

.booster-button__caption {
  font-weight: 300;
}

.booster-button__pic {
  height: 45px;
  width: 45px;
  background-color: var(--bg-color);
  border-radius: 50%;
  transition: background-color 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.booster-button__counter {
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px;
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: $color--basic-blue;
  text-align: center;
  transform: translate(25%, -25%);
  border: 2px solid $color--basic-menu;
}

.booster-button__counter--boolean {
  height: 15px;
  min-width: 15px;
  transform: translate(15%, -15%);
}

.booster-button__img {
  height: 25px;
}

.booster-button__text {
  margin: 15px 0 0;
}

.booster-button--has-value {
  flex-direction: row;

  .booster-button__text {
    margin: 0 0 0 15px;
  }
}

.booster-button--rating .booster-button__text {
  margin: 0 0 0 26px;
}
  .booster-button--rating{
      height: 50px;
  }

  .booster-button--rating .booster-button__text {
    margin: 0 0 0 26px;
  }

.booster-button__rating {
  position: absolute;
  right: -11px;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: 4px;
  background: $color--basic-blue;
  font-size: 11px;
  font-weight: 500;
  color: $color--basic-white;
}
  .booster-button__rating {
    position: absolute;
    bottom: -5px;
    display: flex;
    align-items: center;
    padding: 2px 4px;
    border-radius: 4px;
    background: $color--basic-blue;
    font-size: 11px;
    font-weight: 500;
    color: $color--basic-white;
  }

.booster-button__rating-icon {
  width: 8px;
  right: 8px;
  margin-right: 2px;
}

.booster-button--sidebar .booster-button__pic {
  height: 32px;
  width: 32px;
}

.booster-button--sidebar .booster-button__text {
  margin: 8px 0 0;
}

.booster-button--sidebar .booster-button__img {
  height: 16px;
}

.booster-button--sidebar .booster-button__counter {
  right: -10px;
  top: 3px;
  font-size: 11px;
  height: 21px;
  min-width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and ($screen-less-than-1024) {

  .booster-button--header {
    .booster-button__pic {
      margin-right: 16px;
    }
  }
}

@media screen and ($screen-less-than-768) {
  .booster-button--mobile {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 8px;
    background-color: $color--basic-menu;
    border-radius: 8px;

    .booster-button__pic {
      background-color: $color--basic-superdark-gray;
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }

    .booster-button__img {
      height: 16px;
    }

    .booster-button__text {
      margin: 0;
    }

    .booster-button__title {
      font-size: 13px;
      font-weight: 500;
    }

    .booster-button__counter {
      display: none;
      right: 0;
      top: 0;
      transform: translate(0, 0);

      &--mobile {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: auto;
        padding: 6px 4px;
      }
    }
  }

  .booster-button--header {
    background-color: transparent;
    padding: 0;
    border-radius: 0;
    margin-bottom: 0;

    .booster-button__pic {
      width: 43px;
      height: 43px;
    }
  }

  .booster-button--rating {
    height: 43px;
  }

  .booster-button__rating {
    bottom: 0;
  }

  .booster-button__rating-icon {
    width: 8px;
    right: 8px;
    margin-right: 2px;
  }
}
</style>
